// extracted by mini-css-extract-plugin
module.exports = {"container":"_3qlOL","arrow":"_3pYW4","page":"_2Prl_","active":"_38T0S"};